var _rect, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErpIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#1f396c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 20,
    height: 15,
    rx: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 22,
    x2: 16,
    y2: 22
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 22
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 13,
    x2: 7,
    y2: 10,
    stroke: "#2f6fed"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 13,
    x2: 12,
    y2: 7,
    stroke: "#2f6fed"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 13,
    x2: 17,
    y2: 11,
    stroke: "#2f6fed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpIntegration);
export default __webpack_public_path__ + "static/media/erpIntegration.36aedaf8221508996a514b77541a2080.svg";
export { ForwardRef as ReactComponent };